import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import {
  CurecallInput,
  CurecallSearchableSelect,
  CurecallDropdownButton,
  ECurecallSize,
} from '@honestica/curecall-ui'

const DataTableHeader = ({
  sortOptions,
  sort,
  filterOptions,
  onSearch,
  onSortSelect,
  onFilterSelect,
}: any) => {
  const { t } = useTranslation()
  const [searchedDoctor, setSearchedDoctor] = useState(
    filterOptions?.length === 0 ? filterOptions[0].label : '',
  )

  return (
    <div className="c-mb-3 c-block c-inline-block" id="list-filter-sorter">
      {sortOptions && (
        <div className="c-float-left c-mb-1 c-mr-2">
          <CurecallDropdownButton
            dropdownButtonLabel={t('pages.reviews.sort-by-option', {
              option: sortOptions.find((localSort: any) => localSort.value === sort)
                ? sortOptions.find((localSort: any) => localSort.value === sort).label
                : '',
            })}
            size={ECurecallSize.SMALL}
            items={sortOptions.map((sortOption: any) => ({
              label: sortOption.label,
              onClick: () => onSortSelect(sortOption.value),
            }))}
          />
        </div>
      )}

      <div className="c-flex c-gap-4">
        {filterOptions && filterOptions.length && (
          <CurecallSearchableSelect
            items={filterOptions}
            label={t('pages.reviews.filter-by-doctor')}
            defaultItemSelected={searchedDoctor}
            onClear={() => setSearchedDoctor('')}
            onSelect={({ value }) => {
              onFilterSelect(value)
            }}
          />
        )}

        {onSearch && (
          <CurecallInput
            label={t('pages.reviews.search-by-patient')}
            onChange={(e) => {
              onSearch(e.target.value)
            }}
          />
        )}
      </div>
    </div>
  )
}

export { DataTableHeader }
